var _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 135,
    viewBox: "0 0 180 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 122.4L41.1767 123.3H98.6944H127.8L98.6944 122.4H40.5Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2 14.4V105.3H123.732C129.458 105.3 134.1 100.658 134.1 94.932V14.4H61.2Z",
    fill: "url(#paint1_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.888,
    transform: "matrix(-1 0 0 1 113.58 26.1)",
    fill: "url(#paint2_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.888,
    transform: "matrix(-1 0 0 1 121.356 26.1)",
    fill: "#A1A3A8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.888,
    transform: "matrix(-1 0 0 1 113.58 35.172)",
    fill: "url(#paint3_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.888,
    transform: "matrix(-1 0 0 1 121.356 35.172)",
    fill: "#A1A3A8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.888,
    transform: "matrix(-1 0 0 1 113.58 44.244)",
    fill: "url(#paint4_linear)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.888,
    transform: "matrix(-1 0 0 1 121.356 44.244)",
    fill: "#A1A3A8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.888,
    transform: "matrix(-1 0 0 1 113.58 53.316)",
    fill: "url(#paint5_linear)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.888,
    transform: "matrix(-1 0 0 1 121.356 53.316)",
    fill: "#A1A3A8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.888,
    transform: "matrix(-1 0 0 1 113.58 62.388)",
    fill: "url(#paint6_linear)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.888,
    transform: "matrix(-1 0 0 1 121.356 62.388)",
    fill: "#A1A3A8"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.88801,
    transform: "matrix(-1 0 0 1 113.58 71.46)",
    fill: "url(#paint7_linear)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.88801,
    transform: "matrix(-1 0 0 1 121.356 71.46)",
    fill: "#A1A3A8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.88801,
    transform: "matrix(-1 0 0 1 113.58 80.532)",
    fill: "url(#paint8_linear)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.88801,
    transform: "matrix(-1 0 0 1 121.356 80.532)",
    fill: "#A1A3A8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 38.88,
    height: 3.888,
    transform: "matrix(-1 0 0 1 113.58 89.604)",
    fill: "url(#paint9_linear)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3.88802,
    height: 3.888,
    transform: "matrix(-1 0 0 1 121.356 89.604)",
    fill: "#A1A3A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.95 91.8H40.5V93.8919C40.5 99.6953 45.2046 104.4 51.0081 104.4H123.3C117.584 104.4 112.95 99.7661 112.95 94.05V91.8Z",
    fill: "url(#paint10_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 37.7817,
    y: 119.682,
    width: 92.7366,
    height: 6.33657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35914,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 90.7341,
    y1: 122.139,
    x2: 90.7499,
    y2: 123.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A3A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C3C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 148.663,
    y1: 14.4,
    x2: 148.663,
    y2: 105.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894686,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 38.88,
    y1: 1.944,
    x2: 0,
    y2: 1.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 139.841,
    y1: 91.8,
    x2: 139.841,
    y2: 104.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678311,
    stopColor: "#E0E0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C2C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEmpty);
export default __webpack_public_path__ + "static/media/order-empty.bf6bd6395b9e7344c2c031b28bb7715d.svg";
export { ForwardRef as ReactComponent };